import { handleCountryCodes } from './HandleCountryCodes.js'

const validateContact = (values) => {
    const errors = {};
    if (!values.firstName) {
        errors.firstName = ['The first name is required'];
    }
    if (!values.lastName) {
        errors.lastName = ['The last name is required'];
    }
    if (!values.optIn) errors.optIn = ['Opt in is required'];
    if (values.email) {
        let emails = values.email.replace(/\s/g, '').split(",");
        // eslint-disable-next-line
        let regex = /^\b(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
        let errorEmails = []
        for (let email in emails) {
            if (emails[email] === "" || !regex.test(emails[email].toLowerCase())) {
                errorEmails.push(emails[email])
                errors.email = [`The email(s) ${errorEmails} are not valid`]
            }
        }
    }
    if (values.phone) {
        let phones = values.phone.split(",");
        let regex = /^(\+0?1\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/
        let errorPhones = []
        for (let phone in phones) {
            let pN = phones[phone].replace(/\s/g, '')
            pN = handleCountryCodes(pN)
            if (pN === "" || !regex.test(pN)) {
                errorPhones.push(phones[phone])
                errors.phone = [`The phone number(s) ${errorPhones} are not valid`]
            }
        }
    }
    return errors
};


export default validateContact